import { Icon as AntdIcon } from "@empglabs/backoffice-ui-kit"

export default function Icon(props) {
  return <AntdIcon {...props} />
}
